import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, CloseButton, Container, Form, Image, ProgressBar, Tab, Tabs } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import * as RIcon from "react-icons/fa"
import { LinkContainer } from 'react-router-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Iobserver, LoginInfo } from '../App';
import { isLoggin } from '../service/LoginService';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { Grid, Select } from '@mui/material';
import Plan from './Plan';
import PlanMini from './PlanMini';
import PlanMiniOfficial from './PlanMiniOfficial';
import Button from '@mui/material/Button'
import PlanConfirmDialog from './common/PlanConfirmDialog';

const ManageBilling = () => {
    async function manageBilling(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/checkout/manageBilling").then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getPlanList(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/plan/myList/")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    async function getOfficialPlan(){
        return await new ApiFetch().get(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/coin/official/")
            .then((r)=>r.json().then((json)=>{
            return json
        }))
    }
    // 翻訳
    const {t,i18n} = useTranslation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    // ナビゲート
    const navigate = useNavigate()
    // 画像遅延ロード
    const observer = useContext(Iobserver)

    // URLパラメータ
    let param = useParams();

    const [imageList,setImageList] = useState([...Array(0)])
    const [message,setMessage] = useState('')
    const [item, selectItem] = useState('');
    const [deleted, setDeleted] = useState('');
    const [officialPlan, setOfficialPlan] = useState([])

    // 検索情報
    const [page,setPage] = useState(0)

    // アップロード処理
    const [uploading,setUploading] = useState(false)
    const [progressNow,setProgressNow] = useState(0)
    const [progressLabel,setProgressLabel] = useState(0)
    const maxFileSize = 104857600 // 100MB

    // 投稿完了後
    const [postedStampId,setPostedStampId] = useState("")

    // プラン一覧
    const [planList,setPlanList] = useState([])

    // ダイアログ
    const [show, setShow] = useState(false);
    const [dialogTitle, setDialogTitle] = useState("");
    const [dialogMessage, setDialogMessage] = useState("");
    const [okButtonShow,setOkButtonShow] = useState(false)
    function dialog(title,message){
        setDialogTitle(title)
        setDialogMessage(message)
        setShow(true)
    }

    useEffect(() => {
        if(loginInfo.result === false){
            navigate("/")
        }
    },[loginInfo])

    // 初期処理とページ遷移
    useEffect(() =>{
        // タイトル設定
        document.querySelector("title").textContent = "支援プラン管理 - アワートAI"

        let currentPage = 1
        if(param.page === undefined){
            currentPage = 1
        } else {
            currentPage = parseInt(param.page)
        }
        setPage(currentPage)
        // 初期処理では取得せず、ページ番号が確定してから取得する
        if(page > 0){
            if(loginInfo.result){ // ログイン確認が終わるまで待機する必要あり。
                getPlanList().then(r => {
                    if(r.result){
                        setPlanList(r.data)
                    } else {
                        setPlanList([].concat())
                    }
                })
                getOfficialPlan().then(r => {
                    if(r.result){
                        setOfficialPlan(r.data)
                    } else {
                        setOfficialPlan([])
                    }
                })
            }
        }
    },[loginInfo,deleted,page])

    // 画像遅延ロード
    useEffect(() => {
        //document.querySelectorAll(".lazy").forEach(e => observer.observe(e))
    },[imageList])

    // 削除ボタン
    let okButton
    if(!okButtonShow){
        okButton = ""
    } else {
        okButton = <Button onClick={() => {
            setShow(false)
            deleteStamp(item).then(r=>{
                if(r.result){
                    setDeleted(item)
                } else {
                    dialog("エラー",r.errors)
                }
                setOkButtonShow(false)
            })
        }}>OK</Button>
    }

    return(
    <div className="wrapper">
        <header className="App-header"></header>
        <Dialog title={dialogTitle} message={dialogMessage} show={show} handleClose={() => setShow(false)} button={okButton} />
        <Header />
        <Container className='mt-3 mb-3' style={{fontSize:"24px",fontWeight:"bold",borderLeft:"10px solid lightblue"}}><RIcon.FaStar style={{color:"orange"}} /> {t("common.manageBilling")}</Container>
        <Container>
            <div className={{display:loginInfo.role && loginInfo.role.find(d => d.role_div === "admin") ? "d-block" : "d-none"}}>
            <p style={{fontSize:"24px",fontFamily:"Meityo UI"}} className='mt-4'>クリエイタープラン</p>
                <Grid container spacing={2}>
                {planList.map((d,i) => {
                    return <PlanMini key={i} data={d} />
                })}
                </Grid>
            </div>
            <p style={{fontSize:"24px",fontFamily:"Meityo UI"}} className='mt-4'>公式プラン</p>
            {officialPlan.subscription_id !== undefined ? <PlanConfirmDialog data={{
                "subscription_id":officialPlan.subscription_id,
                "name":officialPlan.name,
                "user_name":"アワートAI公式",
                "amount":officialPlan.amount,
                "status":officialPlan.subscription_id !== undefined ? "ACTIVE" : undefined
            }} /> : (
            <Button className='mb-3' variant='outlined' onClick={() => {
                manageBilling().then(r => {
                    if(r.result){
                        window.location.href = r.data.url
                    } else {
                        dialog("",r.errors)
                    }
                })
            }}>支払方法の管理</Button>
            )}
            <PlanMiniOfficial />
        </Container>
        <Container className='d-flex justify-content-between' style={{width:"200px"}}>
            {page > 1 ? (
                    <Button onClick={() => {
                        let p = page - 1
                        setPage(p)
                        navigate("/stampManage/" + p)
                    } }>{t("common.prev")}</Button>
                ) : <Button disabled>{t("common.prev")}</Button>}
            {imageList.length > 30 ? (
                    <Button onClick={() => {
                        let p = page + 1
                        setPage(p)
                        navigate("/stampManage/" + p)
                    } }>{t("common.next")}</Button>
                ) : <Button disabled>{t("common.next")}</Button>}
        </Container>
        <Footer />
    </div>
    )
}

export default ManageBilling;
